import {
    SET_MENUHEADER
} from "../actions/types";

const initialState = {
    menuactive: '',
    menulocation: '/',
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_MENUHEADER:
            return  {
                ...state,
                menuactive: payload.menuactive,
                menulocation: payload.menulocation,
            };

        default:
            return state;
    }
}
